<mat-toolbar class="topbar mat-bg-card">
  <!-- Sidenav toggle button -->
  <button mat-icon-button
          id="sidenavToggle"
          (click)="toggleSidenav()"
          matTooltip="Toggle Hide/Open">
    <mat-icon class="menu-close">menu</mat-icon>
  </button>
  <!-- <span class="divder"></span> -->
  <div class="appTitle">Event Planner</div>

  <span fxFlex></span>
  <mat-menu #menu="matMenu">
    <button mat-menu-item
            *ngFor="let lang of availableLangs"
            (click)="setLang(lang)">
      <span class="flag-icon mr-8 {{lang.flag}}"></span>
      <span>{{lang.name}}</span>
    </button>
  </mat-menu>


  <!-- Top left user menu -->
  <p class="userDetail"
     *ngIf="userDetail"><span class="userName">{{userDetail.name}}</span> <span
          class="userRole">{{userDetail.userType}}</span></p>
  <button mat-icon-button
          [matMenuTriggerFor]="accountMenu"
          class="topbar-button-right img-button">
    <img [src]=userImage
         class="userProfileImage"
         alt="" />
  </button>

  <mat-menu #accountMenu="matMenu">
    <button mat-menu-item
            (click)="jwtAuth.signout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>{{ "SIGNOUT" | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>